module.exports = __webpack_public_path__ + "img/mv_illustration_pc.73dc75bf.svg";